import { projectClient } from '../../client/client';

export const telemed = {
  meeting: projectClient('/telemed/v2/meeting').post,
  join: projectClient('/telemed/v2/meeting/{encounterId}/join').get,
};
